<template>
  <b-overlay
      :show="loading"
  >
    <b-card
        title="پرداخت رژیم اختصاصی"
    >
      <b-row align-h="center">
        <b-col md="10">
          <b-form-group
              label="نام مشتری"
              label-for="Name"
          >
            <b-form-input
                v-model="Name"
                placeholder="نام مشتری "
                autofocus
                style="width: 200px"
                name="Name"
                autocomplete="off"
            />
          </b-form-group>
          <b-form-group
              label="شماره موبایل"
              label-for="Mobile"
              autocomplete="off"
          >
            <b-form-input
                v-model="Mobile"
                name="Mobile"
                :disabled="true"
                placeholder="شماره مشتری "
                autofocus
                style="width: 200px"
            />
          </b-form-group>
          <b-button variant="primary" class=" mr-2" @click="send">پیامک</b-button>
          <b-button variant="primary" @click="whatsApp">واتس اپ</b-button>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
export default {
  name: 'PaySpecialDiet',
  data() {
    return {
      loading: false,
      Name: null,
      Mobile: this.$route.params.number
    }
  },
  methods:{
    send(){
      this.loading=true
      this.$http.post(this.$api.dedicatedDietList.sendSmsToBuy, {
        Name : this.Name,
        Mobile: this.Mobile,
      }).finally(()=>{
        this.loading = false
      })
    },
    whatsApp(){
      this.loading=true
      this.$http.post(this.$api.dedicatedDietList.whatsApp, {
        Name : this.Name,
        Mobile: this.Mobile,
      }).finally(()=>{
        this.loading = false
      })
    },

  }
}
</script>

<style scoped>

</style>
